import { ref } from 'vue'
import usePut from '../../../core/composables/api/usePut'
import { ApiRequestStatus } from '../../../core/models/api/api-request-status'
import { useUserStore } from '../../../stores/user.store'
import { useMembersStore } from '../../../stores/members.store'
import { useSnackStore } from '../../../stores/snack.store'
import { useI18n } from 'vue-i18n'

export const usePersonalSettings = () => {
  const userStore = useUserStore()
  const membersStore = useMembersStore()
  const snackStore = useSnackStore()
  const { t } = useI18n()

  const { mutate, status: mutationStatus } = usePut<void, { firstName: string; lastName: string }>(
    'me/name',
    true,
  )

  const isNameEditable = ref(false)
  const editableFirstName = ref(userStore.user.firstName)
  const editableLastName = ref(userStore.user.lastName)

  const editName = () => {
    editableFirstName.value = userStore.user.firstName
    editableLastName.value = userStore.user.lastName
    isNameEditable.value = true
  }

  const cancelName = () => {
    editableFirstName.value = userStore.user.firstName
    editableLastName.value = userStore.user.lastName
    isNameEditable.value = false
  }

  const updateName = async () => {
    const firstName = editableFirstName.value.trim()
    const lastName = editableLastName.value.trim()

    if (!firstName || !lastName) {
      snackStore.showError(t('settings.name.update.validation'))
      return
    }

    await mutate({ firstName, lastName })

    if (mutationStatus.value === ApiRequestStatus.Success) {
      await Promise.all([userStore.loadUser(), membersStore.reload()])
      isNameEditable.value = false
      snackStore.showInfo(t('settings.name.update.success'))
    } else {
      snackStore.showError(t('settings.name.update.error'))
    }
  }

  return {
    isNameEditable,
    editableFirstName,
    editableLastName,
    editName,
    cancelName,
    updateName,
    mutationStatus,
  }
}
